import Swiper from 'swiper';

export const initImageCarousel = () => {
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.image-carousel__container', {
      slidesPerView: 'auto',
      breakpoints: {
        375: {
          slidesPerView: 1.16367,
          spaceBetween: 16,
        },
        1536: {
          slidesPerView: 1.58064,
          spaceBetween: 32,
        },
      },
      on: {
        afterInit: function () {
          const wrappers = document.querySelectorAll('.image-carousel__wrapper');
          wrappers.forEach((wrapper) => {
            wrapper?.classList.remove('gap-4', 'lg:gap-8');
          });
        },
      },
    });
  });
};
